import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { QcloudConsoleService } from '../../qcloud-console.service';

@Component({
  selector: 'lib-cancelled-tickets-button',
  templateUrl: './cancelled-tickets-button.component.html',
  styleUrls: ['./cancelled-tickets-button.component.css',  './../base-button/base-button.component.css']
})
export class CancelledTicketsButtonComponent implements OnInit {
	@ViewChild('button') public button: ElementRef;
  isEnabled: boolean;
  isBlocked: boolean;

  constructor(private consoleService: QcloudConsoleService) {
    this.consoleService.ticket.subscribe((val) => {
      if (val.id != 0 && val.id != -1) {
        this.isEnabled = false;
      }
      else {
        this.isEnabled = true;
      }
    })
  }

  ngOnInit(): void {
    this.consoleService.isBlocked.subscribe((val) => {
      this.isBlocked = val;
    })
  }


  public openCancelledTicketsModal() {
    if (this.isEnabled)
      this.consoleService.openCancelledTicketsModal();
  }

}
